/* eslint-env browser */

'use strict';

// disable right click on images
module.exports = {
  disabled(selector) {
    const containers = document.querySelectorAll(selector);
    containers.forEach(container => {
      container.addEventListener('contextmenu', e => {
        if (e.target.nodeName.toLowerCase() === 'img') {
          this._prevent(e);
        }
      });
    });
  },

  _prevent(e) {
    e.stopPropagation();
    e.preventDefault();
    return false;
  },
};
